<div class="autodesk-account">
  <div class="authorized"
       *ngIf="integrationStatus.IsAuthorized; else notAuthorized">
    <div class="title_status">
      <p class="title">{{ 'sources.autodeskAccount.AutodeskAccount' | translate }}</p>

      <div class="app-integration-enabled"
           *ngIf="integrationStatus.IsAppIntegrationEnabled; else appIntegrationNotEnabled">
        <div class="status">
          <i class="material-icons warning-icon blue-color">done</i>
          <p>{{ 'sources.autodeskAccount.Linked' | translate }}</p>
        </div>
      </div>

      <ng-template #appIntegrationNotEnabled>
        <div class="app-integration-not-enabled">
          <div class="status"
               [matTooltip]="'sources.autodeskAccount.NeedToProvideAccess' | translate"
          >
            <i class="material-icons warning-icon red-color">warning</i>
            <p>{{ 'sources.autodeskAccount.AccountNotEnabled' | translate }}</p>
          </div>
          <p class="learn-more"
             (click)="connectBim360Info()"
          >{{ 'sources.autodeskAccount.LearnMore' | translate }}</p>
        </div>
      </ng-template>
    </div>

    <div class="user">
      <div class="avatar">
        <img [src]="integrationStatus.UserImageUrl" alt="">
      </div>

      <div class="name_sign-out">
        <p class="name">{{ integrationStatus.UserName }}</p>
        <p class="sign-out" (click)="signOut()">{{ 'auth.signOut' | translate }}</p>
      </div>
    </div>
  </div>

  <ng-template #notAuthorized>
    <div class="not-authorized">
      <div class="title_status">
        <p class="title">{{ 'sources.autodeskAccount.AutodeskAccount' | translate }}</p>
        <p class="status">{{ 'sources.autodeskAccount.NotSignedInStatus' | translate }}</p>
      </div>
      <a mat-stroked-button class="sign-in-button"
         [href]="autodeskSignInHref">
        <img src="./assets/img/icons/autodesk.svg" alt="">
        <span>{{ 'auth.signIn' | translate }}</span>
      </a>
    </div>
  </ng-template>
</div>
